import { z } from 'zod'

const envSchema = z.object({
  VITE_MAPBOX_ACCESS_TOKEN: z.string(),
  VITE_API_BASE_URL: z.string(),
  VITE_SENTRY_DSN: z.string(),
  VITE_DOMAIN: z.string(),
  VITE_USER_POOL_WEB_CLIENT_ID: z.string(),
  VITE_REGION: z.string(),
  VITE_USER_POOL_ID: z.string(),
  VITE_OAUTH_DOMAIN: z.string(),
  VITE_IDENTITY_POOL_ID: z.string(),
  VITE_SHOULD_MOCK_SERVER: z.stringbool().default(false),
  VITE_PARTNER_LOGO_BASE_URL: z.string(),
  /**
   * Optional override for the Aurora WebSocket URL. When set, the web
   * client connects there instead of the default `wss://aurora.${domain}`.
   * Use to point the SPA at a locally-running `yarn workspace aurora
   * dev:server` (e.g. `ws://localhost:8080`).
   */
  VITE_AURORA_WS_URL: z.string().optional(),
  MODE: z.string(),
  VITE_IS_LOCAL: z.stringbool().default(false)
})

const env = envSchema.parse(import.meta.env)

export const mapboxAccessToken = env.VITE_MAPBOX_ACCESS_TOKEN

export const apiBaseUrl = env.VITE_API_BASE_URL

export const domain = env.VITE_DOMAIN

export const auroraWsUrl = env.VITE_AURORA_WS_URL ?? `wss://aurora.${env.VITE_DOMAIN}`

export const oauthDomain = env.VITE_OAUTH_DOMAIN

export const sentryDsn = env.VITE_SENTRY_DSN

export const awsRegion = env.VITE_REGION

export const userPoolId = env.VITE_USER_POOL_ID

export const userPoolClientId = env.VITE_USER_POOL_WEB_CLIENT_ID

export const identityPoolId = env.VITE_IDENTITY_POOL_ID

export const partnerLogoBaseUrl = env.VITE_PARTNER_LOGO_BASE_URL

export const shouldUseMockServiceWorker = env.VITE_SHOULD_MOCK_SERVER ?? false

export const isDevEnv = () => !isProdEnv()

export const isProdEnv = () =>
  env.MODE === 'production' ||
  env.MODE === 'prod-panorama' ||
  new URLSearchParams(window.location.search).has('prod')

export const isLocalEnv = (override = false) => env.VITE_IS_LOCAL || override
